import { combineReducers } from "redux";
const initialLayoutState = {
 
};

export function newsLayoutReducer(state = initialLayoutState, action: any) {
  switch (action.type) {
    default:
      return { ...state };
  }
}

export default combineReducers({ newsLayout: newsLayoutReducer });
